import actions from './advertiser.actions'
import getters from './advertiser.getters'
import mutations from './advertiser.mutations'

// Initial state
const state = {
  advertisers: [],
  advertiserDetails: {},
  editableAdvertiserFields: {},
  isAdvertisersLoading: false,
  searchTerm: '',
  filters: {
    startDate: undefined,
    endDate: undefined,
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/advertiser/index.js